import { render, staticRenderFns } from "./Crews.vue?vue&type=template&id=84bd0fba&scoped=true"
import script from "./Crews.vue?vue&type=script&lang=js"
export * from "./Crews.vue?vue&type=script&lang=js"
import style0 from "./Crews.vue?vue&type=style&index=0&id=84bd0fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd0fba",
  null
  
)

export default component.exports